import { alertRoutine } from '../../redux/Alerts/routines'
import { connexionUrl } from '../../utils/api';

// Le serveur (/me) signale googleDriveReauth quand le refresh_token Google est
// manquant/révoqué : l'accès Drive (photos, documents) ne fonctionne plus.
// On propose une reconnexion Google avec consentement FORCÉ (prompt=consent),
// seul moyen pour que Google réémette un refresh_token. Non bloquant : la session
// reste active, c'est juste Drive qui est à réautoriser.
export const googleDriveReauthAlertActionCreator = () => (
  alertRoutine.show({
    type: 'snack',
    title: 'Votre accès Google Drive a expiré. Reconnectez-vous pour retrouver vos photos et documents.',
    persist: true,
    closeReasons: [],
    actionTitle: 'Reconnecter Google Drive',
    action: () => {
      window.location.replace(`${connexionUrl}?prompt=consent`)
    },
  })
)
